import { Component, OnInit } from '@angular/core';
import { WeatherFactService, SharedService } from './../../../services';
import { Router } from '@angular/router';

@Component({
  selector: 'fact-weather',
  templateUrl: './fact-weather.component.html',
  styleUrls: ['./fact-weather.component.scss']
})
export class FactWeatherComponent implements OnInit {

  constructor(
    private _fact: WeatherFactService,
    private _shared: SharedService,
    private router: Router
  ) { }

  hideLinks = false;
  getVaalueHideLinks = () => this.hideLinks;
  selectedCity;
  loading = false;
  data;
  timeUTC;
  isType = obj => typeof obj;
  getDayTime(day) {
    let h = (new Date(day)).getHours();
    if ((h >= 0 && h <= 6) || (h >= 19 && h <= 24)) {
      return "night";
    } else if (h >= 7 && h <= 18) {
      return "day";
    }
    return 'day';
  }
  getJustNum = (n) => {
    return Number(n).toFixed(0);
  }
  isNumber = x => x !== null;
  parseTemp(t) {
    return t > 0 ? '+'+t : t
  }
  getFact() {
    this.loading = true;
    this._fact.list({ station: this.selectedCity.id }).subscribe(
      res => {
        if (!res || (res && res.status && res.status == "tech error") ) {
          this._shared.changeFactWidget(false);
        } else {
          // Замена первой запятой в тексте на двоеточие
          if ('code' in res && res.code !== null) {
            res.code.TypeWeather = res.code.TypeWeather.replace(',', ':');
          }

          this.data = res;
          this._shared.changeFactWidget(true);
        }
        // status: "tech error"
        this.loading = false;
      },
      err => {
        this._shared.changeFactWidget(false);
        console.error(err);
        this.loading = false;
      }
    )
  }
  getDirection(dir) {
    if(dir<0){dir = dir + 360;}
    if(dir>360){dir = dir - 360;}
    if(dir >= 0 && dir < 22.5) { return 'Северный' }
    if(dir >= 22.5 && dir < 67.5) { return 'С-В' }
    if(dir >= 67.5 && dir < 112.5) { return 'Восточный' }
    if(dir >= 112.5 && dir < 157.5) { return 'Ю-В' }
    if(dir >= 157.5 && dir < 202.5) { return 'Южный' }
    if(dir >= 202.5 && dir < 247.5) { return 'Ю-З' }
    if(dir >= 247.5 && dir < 292.5) { return 'Западный' }
    if(dir >= 292.5 && dir < 337.5) { return 'С-З' }
    if(dir >= 337.5 ) { return 'Северный' }
  }
  getTimezone() {
    return this.timeUTC ? '+0' : (this.selectedCity.timezone < 0 ? '' + this.selectedCity.timezone : '+' + this.selectedCity.timezone)
  }
  ngOnInit() {
    this._shared.currentCity.subscribe(city => {
      this.selectedCity = city;
      this.getFact();
    });
    this._shared.currentTime.subscribe(time => {
      this.timeUTC = time;
      // console.log(!this.timeUTC ? this.selectedCity.timezone : 0);
      // this.canIuseCalc && this.calculateSunrise();
    });
    if (this.router.url.includes('/observation/meteo-observation')) {
      this.hideLinks = true;
    } else {
      this.hideLinks = false;
    }
  }

}
